import type { EmptyObject } from "@sveabank/cc-common";
import type { SelectedPackage } from "../../types/package";
import type { SelectedProduct } from "../../types/product";
import type { SelectedAddonsRecord } from "./product-section";

// Groups selected addons by productDefinitionId and counts duplicates for the review UI.
export const getSelectedAddonsForReview = (products: SelectedProduct[]) =>
	products
		.filter((product) => product.isAddon && product.productDefinitionId !== "BANKGIRO")
		.reduce<SelectedAddonsRecord | EmptyObject>((acc, curr) => {
			const definitionId = curr.productDefinitionId;

			acc[definitionId] = !acc[definitionId]
				? { count: 1, product: curr }
				: {
						...acc[definitionId],
						count: acc[definitionId].count + 1,
					};

			return acc;
		}, {});

export const calculatePackageSum = (selectedPackage: SelectedPackage, includeAddons = false) =>
	Number(selectedPackage.monthlyFee.amount) +
	selectedPackage.products
		.filter((product) => (includeAddons ? true : !product.isAddon))
		.reduce((acc, curr) => acc + Number(curr.monthlyFee.amount), 0);
